import Loading from 'flow/components/ui-components/Loading';
import useProfiles from 'flow/hooks/useProfiles';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { useHistory, useParams } from 'react-router-dom';
import { generatePath } from 'flow/utils/router-utils';
import AvailableLandline from '../../IncomingCalls/Pages/AvailableLandline';
import Busy from '../../IncomingCalls/Pages/Busy';
import Delay from '../../IncomingCalls/Pages/Delay';
import Disconnect from '../../IncomingCalls/Pages/Disconnect';
import Mobile from '../../IncomingCalls/Pages/Mobile';
import OtherLandline from '../../IncomingCalls/Pages/OtherLandline';

interface Params {
    extensionKey: ExtensionKey;
    profileKey: ProfileKey;
    settingType: 'landline' | 'mobile' | 'busy' | 'delay' | 'disconnected';
}

const ProfileIncomingCallsSettingType = () => {
    const history = useHistory();
    const { extensionKey, profileKey, settingType } = useParams<Params>();
    const { getProfile } = useProfiles(extensionKey);

    const profile = getProfile(profileKey);

    if (!profile) {
        return <Loading />;
    }

    const handleBackClick = () =>
        history.push(
            generatePath(
                routes['settings.profiles.profileKey.incoming-calls'],
                { extensionKey, profileKey },
            ),
        );

    switch (settingType) {
        case 'landline':
            return profile.get('plusId') === 0 ? (
                <AvailableLandline
                    profile={profile}
                    onClickBack={handleBackClick}
                />
            ) : (
                <OtherLandline
                    profile={profile}
                    onClickBack={handleBackClick}
                />
            );
        case 'mobile':
            return <Mobile profile={profile} onClickBack={handleBackClick} />;
        case 'busy':
            return <Busy profile={profile} onClickBack={handleBackClick} />;
        case 'delay':
            return <Delay profile={profile} onClickBack={handleBackClick} />;
        case 'disconnected':
            return (
                <Disconnect profile={profile} onClickBack={handleBackClick} />
            );
        default:
            handleBackClick();
            return null;
    }
};

export default ProfileIncomingCallsSettingType;
